import React from 'react';
import TaxProfileQA from './TaxProfileQA';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import {useSelector} from 'react-redux';
import {RootState} from '../../../..';
import {useGetMessages} from '../../../../hooks';
import {selectQuickLinks, selectTaxSubmitted, selectTaxLoading} from '../../../../selectors';
import {LoadIndicator, Message, Button} from '../../../../components';

//@ts-ignore
import styles from './TaxProfile.pcss';

export interface TaxProfileInterviewInfoProps {
    onClick: (e?) => void;
}

const TaxProfileInterviewInfo = ({onClick = () => {}}) => {
    const quickLinks = useSelector<RootState, any>(selectQuickLinks);
    const isSubmitted = useSelector<RootState, boolean>(selectTaxSubmitted);
    const loading = useSelector<RootState, boolean>(selectTaxLoading);
    const messages = useGetMessages({
        title: 'epic.affiliate.settings.tax.profile.title',
        underReview: 'epic.affiliate.settings.tax.profile.under_review',
        underReviewDesc: {
            code: 'epic.affiliate.settings.tax.profile.desc.submitted',
            args: [quickLinks.privacyPolicy]
        },
        newInterview: 'epic.affiliate.settings.tax.profile.new_interview',
        newInterviewDesc: {
            code: 'epic.affiliate.settings.tax.profile.desc',
            args: [quickLinks.privacyPolicy]
        }
    });

    const info = {profileInfo: null, desc: null};

    if (isSubmitted) {
        info.profileInfo = messages.underReview;
        info.desc = messages.underReviewDesc;
    } else {
        info.profileInfo = messages.newInterview;
        info.desc = messages.newInterviewDesc;
    }

    return (
        <>
            <LoadIndicator messages={messages} isLoading={loading} className={styles.section}>
                <Typography className={styles.title} variant="h4">
                    {messages.title}
                </Typography>
                <Typography variant="body2" dangerouslySetInnerHTML={{__html: info.desc}} />
                <Paper className={styles.profileInfo}>{info.profileInfo}</Paper>
                <Button size="large" disabled={isSubmitted} onClick={onClick}>
                    <Message code="epic.affiliate.settings.tax.profile.begin.interview" />
                </Button>
            </LoadIndicator>
            <TaxProfileQA key="QA" />
        </>
    );
};

export default TaxProfileInterviewInfo;
